import { createThunkEffect } from "../../utilities/ActionUtility";
import * as UserRegistrationEffect from "./UserRegistrationEffect";

export const REQUEST_REGISTER_USER = "UserRegistrationEffect.REQUEST_REGISTER_USER";
export const REQUEST_REGISTER_USER_FINISHED = "UserRegistrationEffect.REQUEST_REGISTER_USER_FINISHED";

const createJSON = (details) => {
    return {
        userDetails: {
            email: details.email,
            firstName: details.firstName,
            lastName: details.lastName,
            phone: details.phone,
            mobilePhone: details.mobilePhone,
            billingAddress: {
                name: details.firstName + " " + details.lastName,
                addressLine1: details.addressLine1,
                addressLine2: details.addressLine2,
                postcode: details.postcode,
                city: details.city,
                country: details.country
            },
            deliveryAddress: {
                name: details.firstName + " " + details.lastName,
                addressLine1: details.deliveryAddressLine1,
                addressLine2: details.deliveryAddressLine2,
                postcode: details.deliveryPostcode,
                city: details.deliveryCity,
                country: details.deliveryCountry
            },
            company: details.company,
            tin: details.tin,
            jobPosition: details.jobPosition,
            createdByAdmin: details.isCreatedByAdmin
        },
        howDidYouHearAboutDS: {
            how: details.howDidYouHearAboutDS,
            other: details.howDidYouHearAboutDSOther
        },
    };
};

export function registerUser(details) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_REGISTER_USER, UserRegistrationEffect.registerUser, createJSON(details));
    };
}
